import {
  Component,
  OnInit,
  Directive,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { AreasService } from "../../master-services/area-services/areas.service";
import swal from "sweetalert2";
import { DecimalPipe } from "@angular/common";
import { Console, error } from "console";
import { OrderService } from "../../master-services/order-service/orderservice.service";
import {
  NgbCalendar,
  NgbDateParserFormatter,
  NgbDatepickerI18n,
  NgbDateStruct,
} from "@ng-bootstrap/ng-bootstrap";

///¡¡¡¡¡Importaciones nuevas

////Termina Importaciones nuevas de la tabla

@Component({
  selector: "app-master-imports-backorder",
  templateUrl: "./master-imports-backorder.component.html",
  styleUrls: ["./master-imports-backorder.component.scss"],
})
export class MasterimportsBackOrderComponent implements OnInit {
  ////Comienza Espacio para declaraciones /////

  priceListMap: { [key: number]: string } = {
    0: "Seleccionar país",
    2: "USA",
    3: "ESPAÑA",
    4: "BELGICA",
    5: "SERVICIO TERCERO",
    6: "REPUESTO NACIONAL",
    7: "SIN",
    8: "USA FPE",
    9: "FLORIDA",
    10: "KANSAS",
    11: "MPE",
  };

  stateListMap: { [key: number]: string } = {
    0: "En canasta",
    1: "Llego el pedido",
    2: "Despachado",
  };

  priceListArray: { key: number; value: string }[] = [];
  consecutive: any;
  now: any;
  user: any;
  selectedOriginId: number = 0;
  state: number = 0;
  import_order: any;
  filteredOrders: any;
  emailLogist: any;
  orderserviceslogist: any;
  ordersFlat: any;
  import_order_disponible:any
  idDeleteBackOrder: any[] = [];
  newUpdateBackOrder: any[] = [];

  ///Tabla
  selectedOrders: any[] = [];
  totalWeight: number = 0;
  totalPLD: number = 0;
  showAssignement: boolean = false;
  importOrder: any;
  secondImportOder: any[] = [];

  orderBy: string = ""; // Campo por el que se ordena
  orderDirection: boolean = true; // true = ascendente, false = descendente
  ///Termina tabla
  ////Termina Espacio para declaraciones /////
  constructor(
    private router: Router,
    private rutaActiva: ActivatedRoute,
    private orderservice: OrderService,
    private calendar: NgbCalendar
  ) {
    this.index();
  }
  ngOnInit() {}

  index() {
    //Obtencion de data

    console.warn("Iniciando el componente");
    this.getImportOrder();
    this.getImportOrderBackOrder();
    

    ///Obtener fecha y usuario
    var date = new Date();
    var day = (date.getDate() < 10 ? "0" : "") + date.getDate();
    let month = (date.getMonth() + 1 < 10 ? "0" : "") + (date.getMonth() + 1);
    var year = date.getFullYear();
    this.now = year + "-" + month + "-" + day;
    this.user = localStorage.getItem("username");
  }

  getPriceListName(priceList: number): string {
    return this.priceListMap[priceList] || "Desconocido";
  }

  getImportOrderBackOrder() {
    console.log("Acaaa haciendo el get de backOrder");
    
    //console.warn("Acaaa implementacion de metodo para obtener data normalita.");
    this.orderservice
      .getImportOrder_backorder()
      .then((data) => {
        const resp: any = data;

        this.import_order = resp.data;
        console.log(
          "Data recibida de ordenes de IMPORTACIONES Normal:",
          this.import_order
        );
      })

      .catch((error) => {
        console.log(error);
      });
  }
  getImportOrder() {
      swal({
        title: "Obteniendo información ...",
        allowOutsideClick: false,
      });
      swal.showLoading();
      this.orderservice
        .getImportOrderBasket()
        .then((data) => {
          const resp: any = data;
          console.log(data);
  
          this.import_order_disponible = resp.data;
          console.warn(
            "Data recibida de Importorders:",
            this.import_order_disponible
          );
         
  
          console.log("Nuevo valor agregado:", this.import_order_disponible);
          swal.close();
        })
        .catch((error) => {
          console.log(error);
        });
    }


    addImportOrder(order: any) {
      console.warn("Acaa paso la orderId", order);
      console.warn("Acaa paso la Id", order.import_order_detail_id);
      if (!order.importDetails) {
        order.importDetails = [];
      }
      order.importDetails.push({
        import_order_consecutive: "",
        other_cant_imports: null,
      });
    }

    removeImportField(order: any, index: number) {
      order.importDetails.splice(index, 1);
    }

    confirmNewImportOrderDetail(order: any) {
        console.log("Acaaa paso la  order", order);
    
       
    
        // Calcula la suma de las cantidades ingresadas en los inputs
        const totalQuantityEntered = order.importDetails.reduce(
          (sum: number, importDetail: any) => {
            return sum + (importDetail.other_cant_imports || 0);
          },
          0
        );
    
        // Verifica si la suma de las cantidades es igual a order.cant_imports
        if (totalQuantityEntered !== order.cant_imports) {
          console.warn(
            `La cantidad total ingresada (${totalQuantityEntered}) no coincide con la cantidad de importación (${order.cant_imports}).`
          );
          swal({
            title: "Las cantidades deben coincidir",
            text: "Error",
            type: "error",
          });
          return;
        }
        const id = order.import_order_detail_id;
        console.log("acaaa id para borrar", id);
        this.idDeleteBackOrder.push(id);
        const roundToTwoDecimals = (value: string | number) =>
          parseFloat(value as string).toFixed(2);
    
        
    
        // Si la validación pasa, se genera el array newImportData
        const newImportData = order.importDetails
          .filter(
            (importDetail: any) => importDetail.import_order_consecutive !== "1"
          )
          .map((importDetail: any) => ({
            orderserviceConsecutive: order.orderserviceConsecutive,
            importOrderConsecutive:  Number(importDetail.import_order_consecutive),
            cant_disp: order.cant_disp,
            cant_imports: importDetail.other_cant_imports,
            crossReferenceCode: order.crossReferenceCode,
            customer_name: order.customer_name,
            description: order.description,
            estimateConsecutive: order.estimateConsecutive,
            order_observation: order.order_observation,
            price_list: order.price_list,
            total_quantity: order.total_quantity,
            unit_cost: order.unit_cost,
            PID_unit: Number(roundToTwoDecimals(order.unit_cost)),
            warehouse_description: order.warehouse_description,
            weight:  Number(roundToTwoDecimals(order.weight)),
            weight_type: order.weight_type,
            quantity_toImport: importDetail.other_cant_imports,
            code: order.code,
            backOrder: 0,
            product_arrived: 0,
            product_remision: 0,
            product_registered: 0,
            cant_registered: 0,
            stock: 0,
            od_id: order.od_id,
            order_logis_id: order.order_logis_id,
            petitioner_email:order.petitioner_email,
            comercial_name:order.comercial_name,
            // id: order.id,
          }));
    
        console.warn("🚀 newImportData generado:", newImportData);
    
        // Agregar los datos validados al array this.secondImportOder y sacarlo del primero
        this.secondImportOder.push(...newImportData);
    
        this.import_order = this.import_order.filter(
          (selectedOrder: any) =>
            selectedOrder.import_order_detail_id !== order.import_order_detail_id
        );
        this.totalWeight = this.import_order.reduce(
          (sum, o) => sum + o.cant_imports * parseFloat(o.weight),
          0
        );
        this.totalPLD = this.import_order.reduce(
          (sum, o) => sum + parseFloat(o.unit_cost) * o.cant_imports,
          0
        );
        //console.log("Datos de importación confirmados:", newImportData);
        console.log(
          "Orden eliminada de imports_order_detail_DIST, nuevo estado:",
          this.import_order
        );
        console.log("segundo array de ordenes:", this.secondImportOder);
    
        this.newUpdateBackOrder = [
          ...this.secondImportOder,
          
        ];
    
        console.warn("Acaaaa newUpdateBackOrder", this.newUpdateBackOrder);
        console.warn("Acaaa ids a eliminar", this.idDeleteBackOrder);
      }

      
      confirmNewImportBackorder() {
        swal({
              title: "Obteniendo información ...",
              allowOutsideClick: false,
            });
            swal.showLoading();

          console.warn("Acaaa confirmacion back order", this.newUpdateBackOrder);
          console.warn("Acaaa ids a eliminar", this.idDeleteBackOrder);
          const data={ids_delete: this.idDeleteBackOrder, combinedData: this.newUpdateBackOrder}
          console.log("Acaaaa pasando la data",data);
        
            this.orderservice.createImportOrderDetailFromBackOrder(data).then((data) => {
                  if (data && typeof data === "object" && "success" in data) {
                    console.log("Se ha creado el post", data);
                    swal({
                      title: "Se ha registrado los pedidos de importacion",
                      type: "success",
                    });
                    swal.close();
                   this.router.navigateByUrl("erp/Importsorder");
                   
                  } else {
                    console.log("Error al crear POSTLOGIST:", data);
                    // Manejo Adicional de errores
                    swal.close();
                    swal({
                      title: "Los items deben de asociarse a un numero de pedido",
                      type: "error",
                    });
                  }
                });
               
        }
  



  ///////
}


// WEBPACK FOOTER //
// ./src/app/master/master-imports-backorder/master-imports-backorder.component.ts